const UsersHeader = ({ onAdd }) => {

    return (
        <div className="flex items-center justify-between">

            <h1 className="text-xl font-doran font-bold">
                مدیریت کاربران
            </h1>

            <button
                onClick={onAdd}
                className="
                flex items-center gap-3 px-4 py-3 rounded-xl
                text-sm transition text-white shadow
                bg-gradient-to-r from-[#543389] to-[#8b6bd9]
                hover:opacity-90
                "
            >
                <div className="w-5 h-5">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H13V7C13 6.44771 12.5523 6 12 6C11.4477 6 11 6.44771 11 7V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H11V17Z"/>
                    </svg>
                </div>

                افزودن کاربر
            </button>

        </div>
    );
};

export default UsersHeader;